import {makeStyles} from '@mui/styles'

export default makeStyles((theme) => ({
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  actionDiv: {
    textAlign: 'center',
  },
}));